import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import moment from 'moment';
import { FULL_DATETIME_FORMAT } from '../constants/app';
let DateMixin = class DateMixin extends Vue {
    constructor() {
        super(...arguments);
        this.now = new Date();
    }
    parseToDate(date) {
        // https://github.com/adopted-ember-addons/ember-pikaday/issues/156
        const parsedDate = moment(date);
        return parsedDate;
    }
    formatDate(dateFormat = FULL_DATETIME_FORMAT, date = null) {
        const datetime = date ? moment(date) : moment();
        return datetime.format(dateFormat);
    }
    getDateFromNow(date) {
        return moment(date).fromNow();
    }
    dateIsInvalid(date) {
        return date == null || !moment(date).isValid();
    }
};
DateMixin = __decorate([
    Component
], DateMixin);
export default DateMixin;
